import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { NTH_USER_AUTO_FOLLOW_SPACES } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';
import { preloadFeatureDiscovery } from '@confluence/feature-discovery/entry-points/preloadFeatureDiscovery.ts';

export const preloadAutoFollowSpacesState = () => {
	return waitForAllReturnWhenError([
		query({
			query: onboardingStateGetOnboardingStateQuery,
			variables: {
				key: [
					NTH_USER_AUTO_FOLLOW_SPACES.HAS_AUTO_FOLLOWED_SPACES,
					NTH_USER_AUTO_FOLLOW_SPACES.HAS_AUTO_FOLLOWED_SPACES_V2,
				],
			},
		}),
		preloadFeatureDiscovery(),
	]);
};
